export enum ExceptionalOpeningHoursQueryKeys {
  GetExceptionalOpeningHours = 'GetExceptionalOpeningHours',
  GetExceptionalOpeningHoursByResourceId = 'GetExceptionalOpeningHoursByResourceId',
}
